"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCalloutBoxCss = void 0;
const getCalloutBoxCss = (themeId) => {
    return `
      .${themeId} .calloutbox {
        box-sizing: border-box;
        margin-top: 5px;
        margin-bottom: 5px;
        padding: 1em 1em 1em 1em;
        display: inline-block;
        width: 100%;
      }
    `;
};
exports.getCalloutBoxCss = getCalloutBoxCss;
